import { render, staticRenderFns } from "./UserFlagNotification.vue?vue&type=template&id=40a0e920&scoped=true&"
import script from "./UserFlagNotification.vue?vue&type=script&lang=js&"
export * from "./UserFlagNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a0e920",
  null
  
)

export default component.exports